import './ToastMessage.css'
import { DefaultToast } from 'react-toast-notifications'
import checkmarkIcon from './checkmark-icon.png'
import infoIcon from './info-icon.png'
import errorIcon from './error-icon.png'

function ToastMessage({ children, ...props }) {
  let image
  let imageClassName
  let messageClassName

  if (props.appearance === 'success') {
    image = checkmarkIcon
    imageClassName = ''
    messageClassName = ''
  } else if (props.appearance === 'info') {
    image = infoIcon
    imageClassName = 'info-image-icon'
    messageClassName = ''
  } else {
    image = errorIcon
    imageClassName = ''
    messageClassName = ''
  }

  return (
    <DefaultToast {...props}>
      <div className="toast-message">
        <img
          className={'toast-icon ' + imageClassName}
          alt="toast-icon"
          src={image}
        />
        <p className={messageClassName}>{props.message}</p>
      </div>
    </DefaultToast>
  )
}

export default ToastMessage
